// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2tqE0","upload":"Small_upload__2wGAB","imageWrap":"Small_imageWrap__NPoxr","removeBtn":"Small_removeBtn__98S4_"};